<template>
  <div class="form-box">
    <div class="title">
      <div v-if="nowTab == 1 || nowTab == 3">学生刷题登录</div>
      <div v-if="nowTab == 2">学生刷题注册</div>
      <div v-if="nowTab == 4">重置密码</div>
    </div>
    <div class="buttons-box" v-if="nowTab == 1 || nowTab == 3">
      <div class="title"></div>
      <div style="margin-top: -10px">
        <a class="text" @click="checkTab(1)" :class="{ hover: nowTab == 1 }"
          >账号登录</a
        >
        <a class="text" @click="checkTab(3)" :class="{ hover: nowTab == 3 }"
          >验证码登录</a
        >
      </div>
    </div>
    <login-password
      v-if="nowTab == 1"
      :role="1"
      @close="closeHandler"
    ></login-password>
    <user-reg
      v-if="nowTab == 2"
      :role="1"
      @goBackLogin="goBackLogin"
    ></user-reg>
    <login-msm v-if="nowTab == 3" :role="1"></login-msm>
    <reset-password
      v-if="nowTab == 4"
      :role="1"
      @goBackLogin="goBackLogin"
    ></reset-password>
    <div class="reg-box" v-if="nowTab == 1 || nowTab == 3">
      <a class="txt-btn" @click="registerHandler()">学生刷题注册</a>
      <a
        v-if="nowTab == 1 || nowTab == 3"
        class="txt-btn find-password"
        @click="findPassword()"
        >找回密码</a
      >
    </div>
  </div>
</template>

<script>
import loginPassword from '@/components/account/model/login-password'
import userReg from '@/components/account/model/user-reg'
import loginMsm from '@/components/account/model/login-msm'
import resetPassword from '@/components/account/model/reset-password'
export default {
  components: {
    loginPassword,
    userReg,
    loginMsm,
    resetPassword,
  },
  props: ['initOpen', 'toTab', 'mode'],
  data() {
    return {
      nowTab: 1,
      role: '',
    }
  },
  watch: {
    initOpen(val) {
      if (val) {
        this.nowTab = 1
      }
    },
    toTab(val) {
      if (val) {
        this.nowTab = val
      }
    },
    mode(val) {
      this.role = val
    },
  },
  created() {},
  mounted() {
    this.nowTab = this.toTab
  },
  methods: {
    changeToLogin() {
      this.nowTab = 1
    },
    closeHandler() {
      this.$emit('close')
    },
    goBackLogin() {
      this.nowTab = 1
    },
    checkTab(tab) {
      this.nowTab = tab
    },
    registerHandler() {
      this.nowTab = 2
    },
    findPassword() {
      this.nowTab = 4
    },
  },
}
</script>

<style lang="scss" scoped>
.form-box {
  padding: 0px 0px 10px;

  .title {
    text-align: center;
    font-size: 20px;
    font-weight: 300;
    padding: 10px 0 20px 0;
  }
  .buttons-box {
    text-align: center;
    padding: 10px 0px;
    font-size: 16px;
    a {
      cursor: pointer;
      padding: 10px 40px;
      border-radius: 5px;

      &.text {
        color: #666;
        border: 1px solid #fff;
      }
      &.hover {
        color: #29bdb9;
        border: 1px solid #29bdb9;
      }
    }
  }
  .reg-box {
    text-align: center;
    padding: 10px 0px;
    font-size: 16px;
    position: relative;
    .txt-btn {
      cursor: pointer;
    }
    .find-password {
      position: absolute;
      right: 66px;
      margin-right: -10px;
      color: #999;
      font-size: 12px;
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/client.vue